import { useState } from "react";
import { auth } from "../firebaseConfig";
import { signInWithEmailAndPassword, signOut, sendPasswordResetEmail } from "firebase/auth";
import { useNavigate } from "react-router-dom";

const ADMIN_EMAILS = new Set([
  "support@climify.com",
]);

const AuthForm = ({ onAuthSuccess }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleAuth = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");
    setLoading(true);
    try {
      const mail = email.trim().toLowerCase();

      if (ADMIN_EMAILS.size && !ADMIN_EMAILS.has(mail)) {
        setError("Not authorized to log in.");
        return;
      }

      const cred = await signInWithEmailAndPassword(auth, mail, password);

      await cred.user.getIdToken(true);

      onAuthSuccess?.();
    } catch (err) {
      setError(err.code === "auth/invalid-credential" ? "Invalid email or password." : (err.message || "Login failed"));
      try { await signOut(auth); } catch {}
    } finally {
      setLoading(false);
    }
  };

  const handleResetPassword = async () => {
    setError("");
    setSuccess("");
    if (!email) {
      setError("Please enter your email to reset password.");
      return;
    }
    try {
      await sendPasswordResetEmail(auth, email);
      setSuccess("Password reset email sent.");
    }
    catch (err) {
      setError(err.message || "Failed to send password reset email.");
    }
  };

  return (
    <div
      className="background-register slide-in-left-transition"
      style={{
        width: "100vw",
        height: "100vh",
        display: "flex",
        zIndex: "999999999",
        justifyContent: "center",
        flexDirection: "column",
        alignItems: "center",
        backgroundColor: "#202122",
      }}
    >
      <img
        src="/neonlogo.png"
        alt=""
        style={{ width: "170px", position: "absolute", top: "35px" }}
      />
      <img
        src="/triade.png"
        alt=""
        style={{ width: "55px", position: "absolute", bottom: "35px" }}
      />
      <h2 style={{ color: "#eef6ff" }}>Login</h2>
      {error && <p style={{ color: "red" }}>{error}</p>}
      {success && <p style={{ color: "green" }}>{success}</p>}

      <form
        onSubmit={handleAuth}
        style={{
          display: "flex",
          justifyContent: "center",
          flexDirection: "column",
          alignItems: "center",
          gap: "24px",
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: "8px",
          }}
        >
          <input
            type="email"
            placeholder="Email"
            value={email}
            className="admin-input"
            onChange={(e) => setEmail(e.target.value)}
            autoComplete="username"
            required
          />
          <input
            type="password"
            placeholder="Password"
            className="admin-input"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            autoComplete="current-password"
            required
          />
          <button
            type="button"
            className="reset-button"
            style={{
              marginLeft: "auto",
            }}
            onClick={handleResetPassword}
          >
            Forgot Password?
          </button>
        </div>
        <button className="register-button" type="submit" disabled={loading}>
          {loading ? "Logging in..." : "Log In"}
        </button>
        <button
          type="button"
          className="back-to-home"
          onClick={() => navigate("/")}
        >
          Back to Home
        </button>
      </form>
    </div>
  );
};

export default AuthForm;
